import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'
import MobileIconUi from './ui/MobileIconUi'

function ButtonWidth({ width, mobileWidth, update, mobileUpdate }) {
  const { isMobile } = useDeviceModeContext()
  const { t } = useTranslation()
  const buttonWidthOptions = [
    { label: t('entity_settings.button.width_type.fluid'), value: 'auto' },
    { label: t('entity_settings.button.width_type.fill'), value: '100%' },
  ]

  const getButtonWidthByValueKey = (width = 'auto') => {
    return buttonWidthOptions.find(option => option.value === width)
  }
  const setValue = buttonWidthValue => {
    const value = buttonWidthValue.value
    isMobile ? mobileUpdate(value) : update(value)
  }

  const value = getButtonWidthByValueKey(isMobile ? mobileWidth : width)

  return (
    <SelectNew
      labelText="settings_options.button.width"
      labelIcon={isMobile && <MobileIconUi />}
      onChange={setValue}
      options={buttonWidthOptions}
      value={value}
    />
  )
}

ButtonWidth.propTypes = {
  width: PropTypes.string,
  mobileWidth: PropTypes.string,
  update: PropTypes.func.isRequired,
  mobileUpdate: PropTypes.func.isRequired,
}

export default ButtonWidth
